import { useQuery } from "@tanstack/react-query";
import { useGetAvailableEntitiesRequest } from "src/services/organizations/queries/configuration";
import { EntitiyType } from "src/types/apps";

export default function useGetEntities() {
	const { data: entities } = useQuery<EntitiyType[]>({
		queryKey: ["entities"]
	});

	const { refetch } = useGetAvailableEntitiesRequest();

	if (!entities) {
		refetch();
	}
	return { entities };
}
